export default {
    intro: `어색하거나 잘못된 표현이 섞여있어요.<br />어색한 부분을 찾아 올바른 표현으로 고쳐보세요!`,
    select: '선택하세요',
    fill: '어색한 부분을 자연스럽게 고쳐 보세요!',
    wrong: '앗 틀렸어요. 다시 시도해 보세요.',
    find: '어색한 부분을 찾아 눌러 보세요.',
    findCount: '개 남아 있어요.',
};
